import '../styles/landing.css'

const apps = [
  {
    name: "Cuentos Mágicos",
    category: "Education",
    description: "Cuentos Mágicos",
    downloads: "5K+",
    iconUrl: "https://lh3.googleusercontent.com/8ElnhCUR9jRGGaH4pEIHqErnplWKStaiC-K_QkTQiqp8F6ibp3hkX9mQ3cCETwAgXLDB-HpdOrv_EqLNWQhGjg",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.vortex.cuentosqueensean",
    rating: 4.3
  },
  {
    name: "Vortex Notas",
    category: "Education",
    description: "Vortex Notas",
    downloads: "5K+",
    iconUrl: "https://lh3.googleusercontent.com/-PuvhVepu8NvjKdCMRq2Zi5MVyLbBz4d69F9OpNAein0VWHXci2NppR2FAIQ-RWYZS_m2T-YT_fMWmMjRkjl8g",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.vortex.vortexnotas",
    rating: 4.3
  },
  {
    name: "Vortex Flashcards",
    category: "Education",
    description: "FlashCards estudia inteligente",
    downloads: "5K+",
    iconUrl: "https://lh3.googleusercontent.com/c57uMNisIa2lRu6FkrE3XcFHVO0YFdPlBw_QfWdUvhglf0FnrdtkH1XiiBDjKel_qtMXVjUHI-FZPwY-bSrxOg",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.vortex.flashcards",
    rating: 4.3
  },
  {
    name: "Vortex Texto a Audio",
    category: "Education",
    description: "convertidor de texto a voz",
    downloads: "5K+",
    iconUrl: "https://lh3.googleusercontent.com/F3yrGBK43fLjEX_3-CocRQOAE5V4xLuPGXfijKScZr_GPqDP7OqivpZ2W8gFpK4zGxqntl1V_VeLabczXJ2k",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.vortex.audio",
    rating: 4.3
  },
  {
    name: "POS VORTEX",
    category: "NEGOCIOS",
    description: "Una solución integral para la gestión de ventas y operaciones comerciales.",
    downloads: "15K+",
    iconUrl: "https://play-lh.googleusercontent.com/P4mbIAXDgcHF_y30g2u4-TR0EEeeFj1ARbpOGh8vwZx0WCLIakZLoGQQXDDuZ1jkAbFKNzoe3b5PWUobGdXiAQ=w240-h480-rw",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.vortex.posvortex",
    rating: 4.8
  },
  
  {
    name: "Tu Brújula",
    category: "Salud",
    description: "Tu Brújula",
    downloads: "5K+",
    iconUrl: "https://play-lh.googleusercontent.com/a5mDUbUBJYXAnHoZ3dXpeXKBuQSTvUQT-J8rKXKdLtigT792OqR7Z6dTrVQFgz-_YD_o7gJorH87pGU9-c1iLMk=s48-rw",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.vortexsoft.confidente",
    rating: 4.3
  },
  {
    name: "Scout Conecta",
    category: "Educación",
    description: "Scout Conecta app",
    downloads: "1K+",
    iconUrl: "https://play-lh.googleusercontent.com/rqXO_FliUgdzPE45iQvCFJOxsrQQ5fzoYSv4mXHL0q2O25hVEBF8S5kimHSzDfGFVbFqnEkGEEtpjqmDOGYe4Tk=s48-rw",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.vortex.scoutconecta",
    rating: 5
  },
  {
    name: "Vortex Audio a Texto",
    category: "Education",
    description: "convertidor de voz a texto",
    downloads: "5K+",
    iconUrl: "https://play-lh.googleusercontent.com/LkAhyjil-Xf9o_4r18-TjbuU_5WVuJ1E0uKGDDA_9JahuevLZP4yU_ncIncqiC7lccTCxeH2ixW0rT1Upxd7MdI=w240-h480-rw",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.vortex.audiotexto",
    rating: 4.3
  }
]

function Stars({ rating }) {
  return (
    <span style={{ color: 'var(--accent)', letterSpacing: '2px', fontSize: '0.95rem' }}>
      {'★'.repeat(Math.round(rating || 0))}
      <span style={{ color: 'var(--border)' }}>{'★'.repeat(5 - Math.round(rating || 0))}</span>
    </span>
  )
}

export default function Screenshots() {
  return (
    <section id="screenshots" className="section section-alt">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Galería de aplicaciones</h2>
          <p className="section-subtitle">
            Conoce todas las aplicaciones que forman parte del ecosistema Vortex para acompañarte en tu desarrollo.
          </p>
        </div>

        <div className="grid grid-3">
          {apps.map((app, index) => (
            <a
              key={index}
              href={app.playStoreUrl}
              target="_blank"
              rel="noreferrer"
              className="screenshot-card app-card-link"
            >
              <div className="app-icon-wrap">
                <img src={app.iconUrl} alt={app.name} />
              </div>
              <div className="app-meta">
                <span className="app-rating"><Stars rating={app.rating} /> {app.rating}</span>
                <span className="app-downloads">⬇ {app.downloads}</span>
              </div>
              <h4>{app.name}</h4>
              <p className="app-desc">{app.description}</p>
              <div className="app-store-link">
                Ver en Google Play <span aria-hidden="true">→</span>
              </div>
            </a>
          ))}
        </div>

        <div className="section-cta">
          <h3>Todas nuestras apps en un solo ecosistema</h3>
          <p>
            Cada aplicación Vortex está diseñada para un propósito: estudiar, crear, escuchar y avanzar.
            Descúbrelas todas en Google Play.
          </p>
          <a href="#availability" className="btn btn-primary">
            Descargar aplicaciones
          </a>
        </div>
      </div>
    </section>
  )
}
